import { render, staticRenderFns } from "./candidate_age_result.vue?vue&type=template&id=3a404fc2&scoped=true&"
import script from "./candidate_age_result.vue?vue&type=script&lang=js&"
export * from "./candidate_age_result.vue?vue&type=script&lang=js&"
import style0 from "./candidate_age_result.vue?vue&type=style&index=0&id=3a404fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a404fc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a404fc2')) {
      api.createRecord('3a404fc2', component.options)
    } else {
      api.reload('3a404fc2', component.options)
    }
    module.hot.accept("./candidate_age_result.vue?vue&type=template&id=3a404fc2&scoped=true&", function () {
      api.rerender('3a404fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/candidate_age_result.vue"
export default component.exports